module.exports = __webpack_public_path__ + "img/logo.720871f6.svg";